import React from "react";
import { Typography, Button, notification } from "antd";
import { useRegisterEnumeratorContext } from "context/RegisterEnumeratorContext";
import { useNavigate } from "react-router-dom";
import { storage } from "utils/storage";
import { useVerifyOtp } from "api/register/useVerifyOtp";

const { Title, Text } = Typography;

const VerificationSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { setRegistrationSteps, registrationSteps } = useRegisterEnumeratorContext();
  const user = storage.getUserFromStorage();
  const verifyOtpMutation = useVerifyOtp();

  const redirectUrl = `/enumerator/profile/update`;

  const handleProfileSetup = async () => {
    try {
      // Proceed with OTP verification without checking email verification
      const parameters = { emailOrPhone: user?.email, companyName: user?.companyName };

      verifyOtpMutation.mutate(parameters, {
        onSuccess: () => {
          setRegistrationSteps({
            ...registrationSteps,
            isEmail: false,
            isPassword: false,
            isVerified: true,
          });
          navigate(redirectUrl);
        },
      });
    } catch (error) {
      notification.error({
        message: "Profile Setup Failed",
        description: (error as any).message || "An error occurred while setting up your profile.",
      });
    }
  };

  return (
    <>
      <Title level={2}>Account Created Successfully</Title>
      <Text type="secondary">
        A verification email has been sent to your email. However, you can proceed with setting up your profile now.
        <br />
        A complete profile helps the enumerator trust your institution.
      </Text>
      <div className="mt-12">
        <Button
          type="primary"
          className="h-12 px-8 border-2 border-border text-base flex justify-center items-center gap-2 bg-primary text-white border-none w-full mt-12"
          onClick={handleProfileSetup}
          loading={verifyOtpMutation.isPending}
        >
          Setup Profile
        </Button>
      </div>
    </>
  );
};

export default VerificationSuccessPage;
